module.exports = __webpack_public_path__ + "assets/img/AquavistaGlass-Website-w720.54be58d5.webp";